import request from '@/utils/request';
// 用户列配置新增修改
/**
 * @param type {
 *   0: 列配置
 *   1: 商品列配置
 *   2: 导出列配置
 *   3: 自定义筛选项配置
 * }
 * @returns 
 */
export function addUserColumnConfigApi(data) {
  return request({
    url: '/ecom/columnConfig/addUserColumnConfig',
    method: 'post',
    data
  });
}
// 用户列配置恢复系统默认设置
export function resetUserColumnConfigApi(data) {
  return request({
    // baseURL: '/test/',
    url: '/ecom/columnConfig/resetUserColumnConfig',
    method: 'post',
    data
  });
}
// 拉取拼多多打印模板
export function getPddPrintTemplateApi(baseTempId) {
  return request({
    baseURL: '/webApi/',
    url: '/CustomerPrintTemp/getPddTemplateURL/' + baseTempId,
    method: 'get'
  });
}
// 打印记录存储
export function savePrintRecordApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/printRecord/save',
    method: 'post',
    data
  });
}
// 存储拉单接口返回结果--拉单日志保存
export function applyWaybillResultApi(data) {
  return request({
    url: '/ecom/luban/applyWaybillResult',
    method: 'post',
    data
  });
}
// 回收运单接口
export function recycleWaybillApi(data) {
  return request({
    url: '/commonRecover/waybillRecover',
    method: 'post',
    data
  })
}
// 回收运单接口
export function recyclePddWaybillApi(data) {
  return request({
    baseURL: '/pdd-api/',
    url: '/pddCloudCommon/commonRecover/waybillRecover',
    method: 'post',
    data
  })
}
// 回收运单接口 淘宝 1688
export function recycleTbAliWaybillApi(data) {
  return request({
    baseURL: '/tb-api/',
    url: '/commonRecover/waybillRecover',
    method: 'post',
    data
  })
}
// 回收运单接口 特惠寄聚合
export function recycleTHJWaybillApi(data) {
  return request({
    url: '/ecom/multi/waybillCancel',
    method: 'post',
    data
  })
}
// 回收运单接口 特惠寄聚合--批量
export function batchRecycleTHJWaybillApi(data) {
  return request({
    url: '/ecom/multi/batchWaybillCancel',
    method: 'post',
    data
  })
}
// 检查圆准达K 码是否有权限修改
export function yzdCheckUserKcodeApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/arriveTime/checkUserKcode',
    method: 'post',
    data
  });
}
// 回收运单接口 京东
export function recycleJdWaybillApi(data) {
  return request({
    baseURL: '/jd-api/',
    url: '/jdCloudCommon/commonRecover/waybillRecover',
    method: 'post',
    data
  })
}
// 航空件服务是否支持对应的收发件地址
export function hkjAddressCheckApi(data) {
  return request({
    baseURL: '/webApi/',
    url: '/hkjAddressCheck',
    method: 'POST',
    data
  });
}
// 查询平台店铺开通航空件接口
export function selectPlatformHkjServiceApi(data) {
  return request({
    baseURL: '/webApi/',
    url: '/basicEcom/selectPlatformHkjService',
    method: 'POST',
    data
  });
}
